import { twMerge } from "tailwind-merge";

export const CountryIcon: React.FC<{
  code: string;
  className?: string;
  style?: React.CSSProperties;
}> = ({ code, className, style }) => {
  return (
    <span
      style={style}
      className={twMerge("font-[Twemoji_Country_Flags]", className)}
    >
      {code}
    </span>
  );
};
